import { render, h } from 'preact';
import { useLayoutEffect as useEffect, useState } from 'preact/hooks';
import Icon from '../Icon'
import router from '../../lib/router'

export default (props)=>{
    var { 
        name,
        label, 
        value,
        onChange = ()=> {},
        range = [],
        fieldType = "text",
        placeholder,
        only=""
    } = props;

    const [ isCustomer,setCustomer ] = useState(false);

    const chooseSite = ()=>{
        wx.setStorageSync(`TEMP_SITE`, value || {});
        window.addEventListener('wxshow',onShow);
        if(!!only) {
            return router.go(`sitehistory?modal=${name}&only=${only}`);
        }
        router.go(`site?modal=${name}`);
    }

    const onShow = ()=>{
        var newData = wx.getStorageSync(`TEMP_SITE`);
        onChange(newData);
        window.removeEventListener('wxshow',onShow);
    }

    var { name:valueName } = value || {};

    return (
        <div className="fieldBody">
            <div className={`itemCell active`} onclick={chooseSite}>
                <div className="itemCell-bd">
                    <div className="input">{valueName || <span className="placeholder">{placeholder}</span>}</div>
                </div>
                <div className="itemCell-ft">
                    <div className="formArrowIcon">
                        <Icon icon="ios-arrow-forward" />
                    </div>
                </div>
            </div>
        </div>
    );
}